import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  AdaptableDubaiIcon,
  ContinousDubaiIcon,
  TimelyDubaiIcon,
  AroundDubaiIcon,
} from "../../../app-constants";

function Techsolution(props) {
  return (
    <div className="techsolution tech_music_solution tech_hire_dubai p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Hire Mobile App Developers From TekRevol?</h2>
            <p>
              When it comes to hiring app developers in KSA, we ensure to
              provide a skillful resource with proven experience. Here are the
              reasons to consider us for hiring mobile app developers:
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="solution_box">
              <div className="solution_box_items">
                <div className="item_icon">{AdaptableDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Adaptable Collaboration Structures</h5>
                  <p>
                    Customized hiring options to suit your project needs and
                    budget, ensuring flexibility in collaboration.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{AroundDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Global Time Zone Alignment</h5>
                  <p>
                    Smooth coordination with our developers across different
                    time zones for efficient communication and progress.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{TimelyDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Efficient Timelines</h5>
                  <p>
                    Agile development process to ensure timely delivery of
                    high-quality mobile applications with optimal performance.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{ContinousDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Post-Launch Maintenance</h5>
                  <p>
                    Ongoing assistance and support after development to ensure
                    the smooth operation and scalability of your mobile app.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
